import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrReturnOrderDetailsItemsModule } from './kn-br-invoice-list-detail-items/kn-br-invoice-list-detail-items.module';
import { KnBrReturnOrderDetailsOverviewModule } from './kn-br-invoice-list-detail-overview/kn-br-invoice-list-detail-overview.module';
import { ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { KnBrCommonAddressModule } from '../kn-br-common-address/kn-br-common-address.module';


@NgModule({
  declarations: [],
  imports: [
    I18nModule,
    CommonModule,
    KnBrReturnOrderDetailsItemsModule,
    KnBrReturnOrderDetailsOverviewModule,
    KnBrCommonAddressModule,
    ConfigModule.withConfig({
      routing: {
        routes: {
          invoiceDetail: {
            paths: ['customer-360/invoice-list/invoice'],
          },
        },
      },
    } as RoutingConfig),
  ]
})
export class KnBrInvoiceListDetailModule { }
